<script>
  import ViewSessionPart from "./ViewSessionPart.svelte";
  import EnduranceSummary from "./general/endurance/EnduranceSummary.svelte";

  import { _ } from "svelte-i18n";
  export let session = { main: [], warmUp: [], conclusion: [] };
  let totalDuration = []
    .concat(session.warmUp)
    .concat(session.main)
    .concat(session.conclusion)
    .reduce(
      (sum, item) => sum + (item.duration ? parseInt(item.duration) : 0),
      0
    );

  // Calculate total time for each section
  $: warmUpTotal = (session.warmUp || []).reduce((sum, part) => {
    return sum + (part.duration ? parseInt(part.duration) : 0);
  }, 0);

  $: mainTotal = (session.main || []).reduce((sum, part) => {
    return sum + (part.duration ? parseInt(part.duration) : 0);
  }, 0);

  $: conclusionTotal = (session.conclusion || []).reduce((sum, part) => {
    return sum + (part.duration ? parseInt(part.duration) : 0);
  }, 0);

  $: sessionTotal = warmUpTotal + mainTotal + conclusionTotal;
</script>

<div class="modal__body">
  <div style="padding-left: 36px; padding-top: 18px">
    <div>
      <b
        >{session.name
          ? session.name
          : "(" + $_("sessions.form.noName") + ")"}</b
      >
      {#if totalDuration > 0}
        <span> ({totalDuration} {$_("sessions.unit")})</span>
      {/if}
    </div>
    {#if session.description && session.description.trim().length > 0}
      <div style="padding-top:5px; padding-bottom:10px">
        <i>{session.description}</i>
      </div>
    {/if}
    <div
      style="display:grid; margin-bottom:9px; margin-left:18px; margin-right:36px; grid-template-columns:18px 3fr 1fr 1fr;"
    >
      {#if session.warmUp && session.warmUp.length > 0}
        <div style="grid-column:1/span 4">{$_("sessions.form.warmup")}</div>
        {#each session.warmUp as part}
          <ViewSessionPart {part} />
        {/each}
        {#if warmUpTotal > 0}
          <div
            style="grid-column:2/span 3; border-top: 1px solid #ddd;
            padding-top: 4px; display:flex;just;justify-content:space-between"
          >
            <div>&nbsp;</div>
            <div style="justify-self: end; font-weight:bold;">
              {warmUpTotal}
              {$_("sessions.unit")}
            </div>
          </div>
        {/if}
      {/if}
      {#if session.main && session.main.length > 0}
        <div style="grid-column:1/4">{$_("sessions.form.main")}</div>
        {#each session.main as part}
          <ViewSessionPart {part} />
        {/each}
        {#if mainTotal > 0}
          <div
            style="grid-column:2/span 3; border-top: 1px solid #ddd; padding-top: 4px; display:flex;just;justify-content:space-between"
          >
            <div>&nbsp;</div>
            <div style="justify-self: end; font-weight:bold;">
              {mainTotal}
              {$_("sessions.unit")}
            </div>
          </div>
        {/if}
        <div style="grid-column:1/4">&nbsp;</div>
      {/if}
      {#if session.conclusion && session.conclusion.length > 0}
        <div style="grid-column:1/span 4">{$_("sessions.form.ending")}</div>
        {#each session.conclusion as part}
          <ViewSessionPart {part} />
        {/each}
        {#if conclusionTotal > 0}
          <div
            style="grid-column:2/span 3; border-top: 1px solid #ddd;
            padding-top: 4px; display:flex;just;justify-content:space-between"
          >
            <div>&nbsp;</div>
            <div style="justify-self: end; font-weight:bold;">
              {conclusionTotal}
              {$_("sessions.unit")}
            </div>
          </div>
        {/if}
      {/if}

      {#if sessionTotal > 0}
        <div
          style="grid-column:1/span 4; font-weight: bold; border-top: 2px double #333; padding-top: 8px; margin-top: 8px;"
        >
          <div style="display:flex;justify-content:space-between">
            <div>{$_("sessions.total")}</div>
            <div style="justify-self:end">
              {sessionTotal}
              {$_("sessions.unit")}
            </div>
          </div>
        </div>
      {/if}
    </div>

    <EnduranceSummary {session} />

    <div>
      {$_("sessions.form.experiencedLoad.title")}: {session.experiencedLoad}
    </div>
    <div>
      {$_("sessions.form.formN.title")}: {session.condition}
    </div>
    {#if session.comments && session.comments.trim().length > 0}
      <div style="padding-top:10px">
        <i>{session.comments}</i>
      </div>
    {/if}
  </div>
</div>
